import axios from '@/core/http'
import { AxiosResponse } from 'axios'
import { saveAs } from 'file-saver'
import { Repository } from './repository'

class SpiderRepository extends Repository {
  URL = 'spiders/spiders/'

  run(spiderId: string): Promise<AxiosResponse<any>> {
    return this.axios.post(`spiders/spiders/${spiderId}/run/`)
  }
  getLastRunId(spiderId: string): Promise<AxiosResponse<any>> {
    return this.axios.get(`spiders/spiders/${spiderId}/last-run/`)
  }
  getRunList(spiderId: string): Promise<AxiosResponse<any>> {
    return this.axios.get(`spiders/spiders/${spiderId}/runs/`)
  }
  getAnalyzerResults(
    spiderId: string,
    dateStart: Date,
    dateEnd: Date,
  ): Promise<AxiosResponse<any>> {
    return this.axios.get(`spiders/spiders/${spiderId}/analyze/`, {
      params: {
        'date_start': dateStart,
        'date_end': dateEnd,
      },
    })
  }
  getAnalyzerExcelFile(spiderId: string, dateStart: Date, dateEnd: Date): any {
    return this.axios
      .get(`spiders/spiders/${spiderId}/analyze/excel/`, {
        responseType: 'blob',
        params: {
          'date_start': dateStart,
          'date_end': dateEnd,
        },
      })
      .then(response => {
        saveAs(new Blob([response.data]), 'Анализ.xlsx')
      })
  }
  bulkUpdate(ids: string[], data: any): Promise<AxiosResponse<any>> {
    return this.axios.patch(`spiders/spiders/bulk-update/`, { ids, ...data })
  }
  bulkCreate(sourceIds: string[]): Promise<AxiosResponse<any>> {
    return this.axios.post(`spiders/spiders/bulk-create/`, { sources: sourceIds })
  }
  bulkDelete(ids: string[]): Promise<AxiosResponse<any>> {
    return this.axios.post(`spiders/spiders/bulk-delete/`, { ids })
  }
  bulkAnalyze(ids: string[]): Promise<AxiosResponse<any>> {
    return this.axios.post(`spiders/spiders/bulk-analyze/`, { ids })
  }
}

class SpiderStatusRepository extends Repository {
  URL = 'spiders/spiders/statuses/'
}

const getSpiderStatusHistory = (spiderId: string) => {
  return axios.get(`spiders/spiders/${spiderId}/status-changes/`)
}
const copySpiderSettings = (originId: number, ids: number[]) => {
  return axios.post(`spiders/spiders/copy-settings/`, { origin: originId, ids })
}

export { SpiderRepository, SpiderStatusRepository, getSpiderStatusHistory, copySpiderSettings }
